// /admin/users — real route. Mirrors apps/web's app/admin/users/page.tsx:
// fully self-contained 'use client' page (fetches/mutates /api/admin/users,
// no route params), lazy-imported directly per the porting convention
// (route-helpers.tsx). Registered from routes/admin.tsx under the `_admin`
// guard (routes/guards.tsx), parity with app/admin/layout.tsx:6.
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { adminRoute } from './guards';

const AdminUsersPage = lazy(() => import('@/app/admin/users/page'));

export const adminUsersRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: '/admin/users',
  component: AdminUsersPage,
});
